import {
  BehavioralFileAction,
  BehavioralModulesLoaded,
  BehavioralMutexAction,
  BehavioralProcessActions,
  BehavioralRegistryActions
} from "../../../@types/rldynamicanalysis";
import {
  isMalwareConfigMutex,
  MalwareConfigAnnotationIcons
} from "../../malware_config";

export const RlCloudSandboxBehavioralItems = {
  process_actions: {
    title: "Process Actions",
    schema: {
      fields: [
        {
          name: "status",
          displayTitle: "Status",
          sortable: true,
          component: (d: BehavioralProcessActions) => d.status,
          style: { width: "15%" }
        },
        {
          name: "path",
          displayTitle: "Path",
          sortable: true,
          component: (d: BehavioralProcessActions) => d.path,
          style: { width: "65%" }
        },
        {
          name: "action_type",
          displayTitle: "Action Type",
          sortable: true,
          component: (d: BehavioralProcessActions) => d.action_type,
          style: { width: "20%" }
        }
      ]
    }
  },
  file_actions: {
    title: "File Actions",
    schema: {
      fields: [
        {
          name: "status",
          displayTitle: "Status",
          sortable: true,
          component: (d: BehavioralFileAction) => d.status,
          style: { width: "15%" }
        },
        {
          name: "file_name",
          displayTitle: "File Name",
          sortable: true,
          component: (d: BehavioralFileAction) => d.file_name,
          style: { width: "20%" }
        },
        {
          name: "file_path",
          displayTitle: "File Path",
          sortable: true,
          component: (d: BehavioralFileAction) => d.file_path,
          style: { width: "50%" }
        },
        {
          name: "action_type",
          displayTitle: "Action Type",
          sortable: true,
          component: (d: BehavioralFileAction) => d.action_type,
          style: { width: "15%" }
        }
      ]
    }
  },
  registry_actions: {
    title: "Registry Actions",
    schema: {
      fields: [
        {
          name: "status",
          displayTitle: "Status",
          sortable: true,
          component: (d: BehavioralRegistryActions) => d.status,
          style: { width: "15%" }
        },
        {
          name: "key_name",
          displayTitle: "Key Name",
          sortable: true,
          component: (d: BehavioralRegistryActions) => d.key_name,
          style: { width: "70%" }
        },
        {
          name: "action_type",
          displayTitle: "Action Type",
          sortable: true,
          component: (d: BehavioralRegistryActions) => d.action_type,
          style: { width: "15%" }
        }
      ]
    }
  },
  mutex_actions: {
    title: "Mutex Actions",
    schema: {
      fields: [
        {
          name: "malware_config",
          displayTitle: "",
          sortable: false,
          component: (d: BehavioralMutexAction) => (
            <MalwareConfigAnnotationIcons
              showMalwareConfig={isMalwareConfigMutex(d)}
            />
          ),
          style: { width: "4%", textAlign: "center" }
        },
        {
          name: "status",
          displayTitle: "Status",
          sortable: true,
          component: (d: BehavioralMutexAction) => d.status,
          style: { width: "13%" }
        },
        {
          name: "name",
          displayTitle: "Name",
          sortable: true,
          component: (d: BehavioralMutexAction) => d.name,
          style: { width: "68%" }
        },
        {
          name: "action_type",
          displayTitle: "Action Type",
          sortable: true,
          component: (d: BehavioralMutexAction) => d.action_type,
          style: { width: "15%" }
        }
      ]
    }
  },
  modules_loaded: {
    title: "Modules Loaded",
    schema: {
      fields: [
        {
          name: "module_name",
          displayTitle: "Module Name",
          sortable: true,
          component: (d: BehavioralModulesLoaded) => d.module_name,
          style: { width: "100%" }
        }
      ]
    }
  }
};
